import React, { useEffect, useState } from 'react'
import StepCounter from '../../components/step-counter'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import { Button, Col, Container, Row } from 'reactstrap'

import './index.scss'
import { userUpdateField } from '../../api/users'
import { accountFormsSubscribe } from '../../api/accounts/forms'
import { checkUser } from '../../core/reducers/user'
import Loader from '../../components/Loader'
import { accountSubscribe } from '../../api/accounts'
import Sdk from '../sdk'
import { toast } from 'react-toastify'

const OnboardingSdk = ({ extended }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  // const [delay, setDelay] = useState('2 week')
  // const [occurences, setOccurences] = useState(3)

  const [form, setForm] = useState(false)
  const [formUrl, setFormUrl] = useState('')
  const [account, setAccount] = useState(useSelector(state => state.accountReducers.account))
  const user = useSelector(state => state.userReducers.user)

  useEffect(() => {
    if (account) {
      if (account.metadata.submissionsCount > 0) {
        try {
          window?.gtag('event', 'conversion', { send_to: 'AW-11479403843/y7uqCM7Y54oZEMOa5-Eq' })
        } catch (e) {
          console.log(e)
        }
        // todo: replace below with upgrade page on /dashboard/upgrade
        // and replace gtag conversion to specific one from email
        /// https://mail.google.com/mail/u/0/#inbox/FMfcgzQbfLQCVwTKhjcHXbvWbgrZHhpl
        if (account.metadata.permium) {
          navigate('/dashboard')
        } else {
          navigate('/dashboard/subscription')
        }
        return () => {}
      }

      const unsubscribe = accountFormsSubscribe(account.id, (forms) => {
        const formData = forms[0]

        setForm(formData)
      })

      return unsubscribe
    }

    if (!user.metadata.onboarding) {
      userUpdateField({ field: 'onboarding', value: true })
      dispatch(checkUser()) // reload user data in state
    }
  }, [account])

  useEffect(() => {
    return accountSubscribe(account.id, (accountData) => {
      setAccount(accountData)
    })
  }, [])

  useEffect(() => {
    if (account && form) {
      setFormUrl(`https://pmf-engine.com/form/${account.id}/${form.id}/testUserId`)
    }
  }, [account, form])

  return <Container className="onboarding onboarding-sdk">
    <Row>
      <center>
        <StepCounter step={5} steps={5} />
      </center>
    </Row>
    <Row className="form-row">
      <h1>Publish the PMF survey, we’re waiting for the first event
        <br />
        <br />
        {form &&
          <>
            <div className="form-url">
                <a href={formUrl}
                  target="_blank"
                  rel="noreferrer"
                >{formUrl}</a>
                </div>
            <Row className="form-url-copy">
              <Col className="form-url-copy-url">
                <a
                  href={formUrl}
                  target="_blank"
                  rel="noreferrer"
                >Your form</a>
              </Col>
              <Col>
                <Button onClick={() => {
                  navigator.clipboard.writeText(`https://pmf-engine.com/form/${account.id}/${form.id}/testUserId/testUseragent`)
                  toast.success('Form URL copied to clipboard')
                }}>Copy form URL</Button>
              </Col>
            </Row>

          </>
        }
      </h1>
    </Row>

    {account.metadata.submissionsCount === 0 &&
      <Row>
        <center>
          <Loader />
        </center>
        <br />
        <br />
        <br />
        <p>Waiting for first survey response</p>
      </Row>
    }

    {account && account.id &&
      <Sdk account={account} />
    }

  </Container>
}

export default OnboardingSdk
